module.exports = __webpack_public_path__ + "static/img/5.3da31bed.png";